import { DefaultFooter } from '@ant-design/pro-layout';
import MaintenancePopup from '../MaintenancePopup';

/** Shared footer — Excel Indo: © {year} T-connect Co., Ltd. (một chỗ dùng chung). */
const COPYRIGHT_COMPANY = 'T-connect Co., Ltd.';

const Footer: React.FC<{
  className?: string;
}> = ({ className }) => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <MaintenancePopup />
      <DefaultFooter
        className={className}
        // DefaultFooter renders: © {copyright}
        copyright={`${currentYear} ${COPYRIGHT_COMPANY}`}
        links={[]}
      />
    </>
  );
};

export default Footer;
